module.exports = __webpack_public_path__ + "img/img_ticket_fanjin.9838cd06.png";